import API from "../../../app/api";

export const getShopby = async () => {
  try {
    const res = await API.get("/banners/shop-by-items");
    if (!res.data?.success) {
      throw new Error(res.data?.message || "Failed to fetch Shop By items");
    }
    return res.data.data || {};
  } catch (error) {
    console.error("getShopby error:", error);
    return {};
  }
};